module.exports = "\n  <div id=\"mynetwork\"></div>\n"